import {useEffect, useState} from 'react';
import useApi from "./useApi";
import {IssuerCode} from "../pages/gestion-saisie-de-paiement/gestion-saisie-de-paiement";
import IConfiguration from "../models/IConfiguration";
import {TransactionType} from "../pages/gestion-paiement/gestion-paiement";

interface TpvResult {
    approved: boolean
    reference: string,
    typePaiement: IssuerCode,
    recuTPV: string,
}

const useTpv = () => {
    const {getData: getConfiguration} = useApi<IConfiguration[]>("configuration");
    const [ipTpv, setIpTpv] = useState("")
    const [portTpv, setPortTpv] = useState(0);
    const [isTpvServiceActived, setIsTpvServiceActived] = useState(false);

    useEffect(() => {
        const abortController = new AbortController();
        fetch(`http://localhost:${5238}/computername`, {
            method: "get",
            mode: "cors",
            headers: {
                "Accept-Language": 'FR',
                "Accept": "*/*"
            },
            signal: abortController.signal
        })
            .then(result => result.text())
            .then(computerName => {
                if (computerName === "") return;

                return getConfiguration({customPath: `configuration/tpvInfo/${computerName}`}).then((configuration) => {
                    setIpTpv(configuration[0].keyValue.split(":")[0])
                    setPortTpv(Number(configuration[0].keyValue.split(":")[1]))
                    setIsTpvServiceActived(true)
                });
            })
            .catch(error => {

            })
        return () => abortController.abort();
    }, []);

    const envoitcommand = async (montant: number, typePaiement: TransactionType) => {
        let methodName: string;
        switch (typePaiement) {
            case TransactionType.Refund:
                methodName = "refund"
                break;
            case TransactionType.Preauth:
                methodName = "PreAuth";
                break;
            case TransactionType.PreauthCompletion:
                methodName = "PreAuthCompletion"
                break;
            default:
                methodName = "sale"
                break;
        }

        const response = await fetch(`http://localhost:${5238}/${methodName}?montant=${montant}&ip=${ipTpv}&port=${portTpv}`);
        return response.json() as unknown as TpvResult;
    }

    return {
        envoitcommand,
        isTpvServiceActived
    };
}

export default useTpv;